import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";

interface CustomSwitchProps {
  isChecked?: boolean;
  onChange: (checked: boolean) => void;
  size?: "xs" | "sm" | "md" | "lg";
}

// Tamanhos personalizados
const sizeConfig = {
  xs: { width: "30px", height: "14px", ball: "10px", lineHeight: "16px" },
  sm: { width: "40px", height: "18px", ball: "14px", lineHeight: "20px" },
  md: { width: "50px", height: "24px", ball: "18px", lineHeight: "5px" },
  lg: { width: "60px", height: "30px", ball: "22px", lineHeight: "6px" },
};

export default function CustomSwitch({ isChecked = false, onChange, size = "md" }: CustomSwitchProps) {
  const config = sizeConfig[size];

  return (
    <Box
      as="button"
      width={config.width}
      height={config.height}
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      position="relative"
      onClick={() => onChange(!isChecked)}
      _hover={{ cursor: "pointer" }}
    >
      <Box
        position="absolute"
        top="50%"
        left="0"
        right="0"
        height={config.lineHeight}
        bg="gray.300"
        rounded="full"
        transform="translateY(-50%)"
      />

      <motion.div
        layout
        style={{
          width: config.ball,
          height: config.ball,
          backgroundColor: isChecked ? "green" : "red",
          borderRadius: "50%",
          position: "absolute",
          boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
        }}
        animate={{
          left: isChecked ? `calc(${config.width} - ${config.ball} - 3px)` : "3px",
        }}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
      />
    </Box>
  );
}
